import MyAccountInvoices from './MyAccountInvoices'

export default MyAccountInvoices
// eslint-disable-next-line import/export
export * from './MyAccountInvoices'
